import * as React from 'react'
import { HashRouter as Router, Route } from 'react-router-dom'
import Header from 'containers/Header'
import Main from 'containers/Main'
import UploadWidget from 'components/UploadWidget/index.js'
import Details from 'containers/Details'
import 'fb'
import './globalStyles'

export default () => (
  <React.Fragment>
    <Header name={''} />
    <Router>
      <main>
        <Route exact={true} path={'/'} component={Main} />
        <Route path={'/new'} component={UploadWidget} />
        <Route path={'/:tag/:id'} component={Details} />
      </main>
    </Router>
  </React.Fragment>
)



// WEBPACK FOOTER //
// ./src/App.tsx